import React, { useEffect, useRef } from 'react';
import styles from './ContextMenu.module.scss';

function ContextMenu({ x, y, onClose, options }) {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      className={styles.contextMenu}
      style={{
        top: y,
        left: x,
      }}
    >
      {options.map((option) => (
        <div
          key={option.label}
          onClick={() => {
            option.onClick();
            onClose();
          }}
          className={`${styles.menuItem} ${option.selected ? styles.selected : ''}`}
        >
          {option.icon && <span>{option.icon}</span>}
          {option.label}
          {option.selected && (
            <span className={styles.checkmark}>✓</span>
          )}
        </div>
      ))}
    </div>
  );
}

export default ContextMenu; 